import React from "react";
export interface Props {
  label: any;
  onClick: () => void;
  isActive: boolean;
  tabBtnStyle?: React.CSSProperties;
}
const Tab = ({ label, onClick, isActive, tabBtnStyle }: Props) => (
  <button
    className={`tab${isActive ? " " + "active" : ""}`}
    onClick={onClick}
    style={tabBtnStyle && tabBtnStyle}
    tabIndex={isActive ? 0 : -1}
    role="tab"
    aria-selected={isActive}
    aria-controls={`panel-${label}`}
  >
    {label}
  </button>
);

export default Tab;
